import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LAZY_VIEW_ENTRY_COMPONENT } from './../../lazy-view/lazy-view-entry-component.injection-token';

import { ViewCacheOperationModule } from '../../view-cache-operation/view-cache-operation.module';
import { DialogModule } from '../dialog/dialog.module';
import { SharedComponentsModule } from '../directives/shared-components.module';
import { InstrumentationModule } from '../instrumentation/instrumentation.module';
import { InputDialogComponent } from './input-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        DialogModule,
        InstrumentationModule,
        SharedComponentsModule,
        FormsModule,
        ViewCacheOperationModule
    ],
    declarations: [
        InputDialogComponent
    ],
    exports: [
        InputDialogComponent
    ],
    entryComponents: [
        InputDialogComponent
    ],
    providers: [
        { provide: LAZY_VIEW_ENTRY_COMPONENT, useValue: InputDialogComponent }
    ]
})
export class InputDialogModule {
}
